import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { Locale } from './i18n';

interface UiState {
  locale: Locale;
  setLocale: (next: Locale) => void;
  toggleLocale: () => void;
}

const noopStorage: Storage = {
  length: 0,
  clear: () => undefined,
  getItem: () => null,
  key: () => null,
  removeItem: () => undefined,
  setItem: () => undefined,
};

export const useUiStore = create<UiState>()(
  persist(
    (set, get) => ({
      locale: 'en',
      setLocale: (next) => set({ locale: next }),
      toggleLocale: () => set({ locale: get().locale === 'en' ? 'zh' : 'en' }),
    }),
    {
      name: 'pocketledger-ui',
      storage: createJSONStorage(() =>
        typeof window !== 'undefined' ? window.localStorage : noopStorage
      ),
    }
  )
);
